import React, { forwardRef, useEffect, useState } from 'react';
import { readingIndicatorPropTypes } from './ReadingIndicatorPropTypes';
import RequestAnimationFrameManager from '@App/common/utils/RequestAnimationFrameManager';
import * as styles from './ReadingIndicator.module.scss';
const calculateProgress = targetEl => {
  const targetTop = targetEl.getBoundingClientRect().top + window.scrollY;
  const targetHeight = targetEl.scrollHeight;
  const scrollPosition = window.scrollY;
  const distanceScrolled = scrollPosition - targetTop;
  const progress = distanceScrolled / targetHeight;
  return Math.max(0, Math.min(progress, 1));
};
const ReadingIndicator = /*#__PURE__*/forwardRef((_, ref) => {
  if (!ref) {
    return null;
  }
  const {
    0: scrolledValue,
    1: setScrolledValue
  } = useState(0);
  useEffect(() => {
    const targetEl = ref.current;
    const onScrollSetScrollOffset = () => {
      setScrolledValue(calculateProgress(targetEl));
    };
    onScrollSetScrollOffset();
    RequestAnimationFrameManager.addEventListener('scroll', onScrollSetScrollOffset);
    return () => RequestAnimationFrameManager.removeEventListener('scroll', onScrollSetScrollOffset);
  }, [ref]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootBar,
    style: {
      transform: `scaleX(${scrolledValue})`
    }
  }));
});
ReadingIndicator.displayName = 'ReadingIndicator';
export default ReadingIndicator;